module.exports = __webpack_public_path__ + "static/media/img_flow4@2x.6a93da05.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/PC/@2x/img_flow4@2x.png
// module id = 916
// module chunks = 0